import { IGeopoint } from '@mayfield/sanity';

export const CENTRE_OF_AUSTRALIA: IGeopoint = {
  lat: -25.640623,
  lng: 134.077358
};

export const GOOGLE_PLACES_API_STATE_TYPE = 'administrative_area_level_1';
export const GOOGLE_PLACES_API_CITY_TYPE = 'colloquial_area';
